module.exports = __webpack_public_path__ + "img/8_f38ec4a8e.png";